import React from 'react';
import { Link } from 'react-router';

import {
	PrimaryButton,
	FlatSecondaryButton,
	FloatingDropDownMenu,
	DropDownMenuItem
} from '../Ui';
import Icon from '../common/components/Icon';

function ProjectDetails({
	project = { estimates: [] },
	onClick,
	onDeleteProject
}) {
	const finitiontext = project.surface_treatment_code === 'LN'
		? 'laiton nickelé'
		: 'laiton poli';
	const redirectRoute = project.state === 'init' ? 'clone-v2' : 'plan';
	const estimatesNumber = project.estimates.length;
	return (
		<div className="c-project-details">
			<header className="c-project-details__header">
				<div className="c-project-details__overlay">

					<p style={{ fontSize: '22px', marginBottom: '8px' }}>
						{project.name}
					</p>
					<div className="c-project-details__primary-actions">
						<a
							style={{ marginRight: '20px' }}
							href="https://www.legallais.com/user/estimate/"
							target="blank"
						>
							<FlatSecondaryButton
							>{`Voir mes devis (${estimatesNumber})`}</FlatSecondaryButton>
						</a>
						<Link
							to={
								'/app/project/' +
									encodeURIComponent(project.project_id) +
									'/' +
									redirectRoute
							}
						>
							<div>
								<PrimaryButton>
									Editer le plan
								</PrimaryButton>
							</div>
						</Link>

					</div>

					<div className="c-project-details__floating-drop-down-menu">
						<FloatingDropDownMenu>
							<DropDownMenuItem
								onClick={() => onClick('edition')}
							>
								Editer le projet
							</DropDownMenuItem>
							<DropDownMenuItem
								onClick={() => onClick('duplication')}
							>
								Dupliquer le projet
							</DropDownMenuItem>
							<DropDownMenuItem onClick={onDeleteProject}>
								Supprimer le projet
							</DropDownMenuItem>
						</FloatingDropDownMenu>
					</div>

				</div>
			</header>
			<div className="c-project-details__details">
				<p><b>Ville :</b> {project.city}</p>
				<p>
					<b>Date de fin de chantier :</b> {project.date_of_receipt}
				</p>
				<p><b>Finition :</b> {finitiontext}</p>
				<p><b>Email :</b> {project.email}</p>
				<p><b>Commentaire :</b> {project.comment}</p>
			</div>
		</div>
	);
}

export default ProjectDetails;



// WEBPACK FOOTER //
// ./src/js/project-v2/ProjectDetails.js